<template>
    <div id="app" class="app">
        <LoadingComponent v-show="pageLoading"></LoadingComponent>
        <router-view v-if="activityData" :activityData="activityData"/>
        <base-component :baseData="baseData" v-if="baseData"></base-component>
    </div>
</template>

<script>

import COVER from '@/utils/COVER'
import BaseComponent from '@/components/Base'
import LoadingComponent from '@/components/Loading'

import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            activityData: null,
            baseData: null
        }
    },
    created() {
        this.aid = this.$route.query.id || ''
        this.getActivityData();
        this.$track(this.aid, 'load');
    },
    computed: {
		...mapState(['pageLoading']),
	},
    components: {
        BaseComponent,
        LoadingComponent
    },
    methods: {
        getActivityData() {
            COVER.$get('/activity/config', {
                aid: this.aid
            }).then((res) => {
                if(res.errno == 0) {
                    let data = res.data
                    document.title = data.title
                    this.activityData = Object.assign(data.templateConfig, {title: data.title, isAppShow: data.isAppShow})
                    this.baseData = Object.assign({
						isAppShow: data.isAppShow,
						music: data.music,
						share: data.share,
						isEnd: data.serverTime >= new Date(data.endTime).getTime(),
					}, data.openApp || {});
                } else {

                }
            })
        },
    }
}
</script>